import React, { useEffect, useState } from 'react';
import Modal from '@mui/material/Modal';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import DeleteIcon from '@mui/icons-material/Delete';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import styles from './style.module.css'
import { DragDropProvider } from '@dnd-kit/react';
import { useSortable } from '@dnd-kit/react/sortable';
import ApiConfig from '../../utils/services/apiConfig'
import { useKeycloak } from '@react-keycloak/web';
import { useMountEffect } from '../../utils/hooks';

// Function to generate random GUID
const generateGUID = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

const reorder = (list, startIndex, endIndex) => {
    // console.log("reordering list", list);
  const result = [...list];
  const [removed] = result.splice(startIndex, 1);
  // console.log("removed item", removed);
  result.splice(endIndex, 0, removed);
  // console.log("new list after reorder", result);

  // Create new objects with updated SeqId instead of mutating
  const updatedResult = result.map((tl, index) => ({
    ...tl,
    SeqId: index
  }));

  // console.log("list after updating seq id", updatedResult);
  return updatedResult;
  };

function SortableTaskItem({ id, index, task, tasks, tasklistTasks, onDelete, onSelect }) {
  const {
    ref,
    isDragging,
  } = useSortable({ id, index });

  const style = {
    opacity: isDragging ? 0.5 : 1,
    display: 'flex',
    flex: 1,
    marginBottom: '8px',
    padding: '8px',
    backgroundColor: 'var(--muted-bg, #f5f5f5)',
    borderRadius: '4px',
  };

  const displayTask = tasks.find(tl => tl.Id === tasklistTasks[index].RobotTaskId.Id) || task;

  return (
    <div ref={ref} style={style}>
      <div style={{ display: "flex", flex: 0.05, alignItems: 'center', justifyContent: "center", cursor: 'grab' }}>
        <DragIndicatorIcon />
      </div>
      <div style={{ display: "flex", flexDirection: "column", flex: 0.9, marginLeft: '8px' }}>
        <Select
          value={displayTask}
          onChange={(e) => onSelect(e, index)}
          fullWidth
          size="small"
        >
          {tasks.map((tl, idx) => (
            <MenuItem key={idx} value={tl}>
              {tl.Name}
            </MenuItem>
          ))}
        </Select>
      </div>
      <Button
        style={{ display: "flex", flex: 0.05, alignItems: 'center', justifyContent: "center" }}
        onClick={() => onDelete(index)}
      >
        <DeleteIcon />
      </Button>
    </div>
  );
}

function AddTasklist(props) {
    const [tasklistTasks, setTasklistTasks] = useState([])
    const [tasklist, setTasklist] = useState({
      Id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
      Name: "",
      Description: "",
      Tasks: [],
      Deleted: false,
      CreatedBy: "system",
      UpdatedBy: "system",
    })

    const tasks = props.tasks

    // var tasklist = {
    //   Id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    //   Name: "",
    //   Description: "",
    //   Tasks: [],
    //   Deleted: false,
    //   CreatedBy: "system",
    //   UpdatedBy: "system",
    // }

    var tasklisttask = {
        RobotTaskId: {
          Id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
          Name: "string",
          Type: "string",
          Command: "string",
          Deleted: false,
          CreatedBy: "system",
          UpdatedBy: "system"
        },
        SeqId: 0
      }

    // const getFormInitials = () => { // Add api call to get initials
    //   Promise.all([
    //   ]).then(results => {
    //     console.log("got results")
    //   }).catch(error => {
    //     console.error(error);
    //   });
    // }

    useEffect(() => {
      // console.log(props.tasklist)
      // console.log(tasks)
      if (props.tasklist !== null && props.tasklist !== undefined){
        // console.log("tasklist is not null or undefined")
        setTasklist(props.tasklist)
        setTasklistTasks(props.tasklist.Tasks)
      }
    }, [props.tasklist, props.openAddTasklist]);

    const addTasklistTask = () => {
      if (tasks.length > 0) {
        const newTask = {
          ...tasklisttask,
          Id: generateGUID(),
          RobotTaskId: tasks[0],
          SeqId: tasklistTasks.length
        }
        setTasklistTasks((prevTasklistTasks) => ([
          ...prevTasklistTasks,
          newTask
        ]))
      }
    }

    const formSubmit = () => {

      console.log("Callback function when form is submitted!");
      tasklist.Tasks = tasklistTasks
      // console.log(tasklistTasks)
      // console.log(tasklist)
      // console.log("Form Values ", values);
      // const newTasklist = [...tasklist]
      // newTasklist.Name = values.Name
      // newTasklist.Description = values.Description
      // newTasklist.Tasks = tasklistTasks
      if(String(props.mode) === String("add")){
        props.addTasklist(tasklist)
      } else {
        props.updateTasklist(tasklist)
      }
      // // console.log(tasklist)
      // setTasklistTasks([])
      // setTasklist({
      //   Id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
      //   Name: "",
      //   Description: "",
      //   Tasks: [],
      //   Deleted: false,
      //   CreatedBy: "system",
      //   UpdatedBy: "system",
      // })
      handleClose()
    }

    const handleClose = () => {
      setTasklistTasks([])
      setTasklist({
          Id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
          Name: "",
          Description: "",
          Tasks: [],
          Deleted: false,
          CreatedBy: "system",
          UpdatedBy: "system",
        })
      props.handleClose()
    }

    const handleChange = (event)=>{
      // console.log(event.target.name)
      setTasklist({
        ...tasklist,
        [event.target.name]:event.target.value,
      })
    }
    // const {handleChange, values,errors,handleSubmit,handleClose} = useForm(formSubmit);
    // const formClose = () => {
    //   props.handleClose()
    //   handleClose()
    // }

    function handleDragEnd(event) {
      if (event.canceled) return;
      const { source } = event.operation;
      const { initialIndex, index } = source;
      console.log(initialIndex, index)
      if (initialIndex !== undefined && index !== undefined && initialIndex !== index) {
        const newList = reorder(tasklistTasks, initialIndex, index);
        console.log(newList)
        setTasklistTasks(newList);
      }
      // if (!result.destination) {
      //   return;
      // }

      // if (result.destination.index === result.source.index) {
      //   return;
      // }

      // const tlts = reorder(
      //   tasklistTasks,
      //   result.source.index,
      //   result.destination.index
      // );

      // tlts.forEach((t, index)=>{
      //   // console.log(index)
      //   t.SeqId = index
      // })

      // setTasklistTasks(tlts);
    }

    const handleTaskSelectChange = (event, index) => {
      const newTasklistTasks = [...tasklistTasks]
      newTasklistTasks[index].RobotTaskId = event.target.value
      newTasklistTasks.forEach((t, taskIndex) => {
        t.SeqId = taskIndex
      })
      setTasklistTasks(newTasklistTasks)
    };

    const handleDeleteTasklistTask = (index) => {
      // console.log(tasklisttask, index)
      const newTasklistTasks = [...tasklistTasks]
      newTasklistTasks.splice(index, 1)
      // console.log(newTasklistTasks)
      newTasklistTasks.forEach((t,index)=>{
        t.SeqId = index
      })
      setTasklistTasks(newTasklistTasks)
    }

    const renderTask = (task, index) => {
      tasks.forEach((t)=>{
        if(String(t.Id) === String(tasklistTasks[index].RobotTaskId.Id)){
          task=t
        }
      })
      // Use tasklist's RobotTasklistId as stable ID instead of array index
      const stableId = tasklistTasks[index].Id;
      return (
        <SortableTaskItem
          key={stableId}
          id={stableId}
          index={index}
          task={task}
          tasks={tasks}
          tasklistTasks={tasklistTasks}
          onDelete={handleDeleteTasklistTask}
          onSelect={handleTaskSelectChange}
        />
      );
    }

    return(
      <Modal
        open={props.openAddTasklist}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box component="form" sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '50%',
            height: '50%',
            bgcolor: 'background.paper',
            border: '2px solid',
            borderColor: 'divider',
            borderRadius: 10,
            boxShadow: 24,
            p: 4,
            overflowY: "auto"
          }}>
          <Typography variant="h6" gutterBottom>
              {String(props.mode) === String("add") ? "Create New Tasklist" : "Edit Tasklist"}
          </Typography>
          <TextField
              required
              fullWidth
              label="Task Name"
              value={tasklist.Name}
              name="Name"
              onChange={handleChange}
              margin="normal"
          />
          <TextField
              required
              fullWidth
              label="Description"
              value={tasklist.Description}
              name="Description"
              onChange={handleChange}
              margin="normal"
          />
          <Typography gutterBottom>
              Tasks
          </Typography>

        <DragDropProvider onDragEnd={handleDragEnd}>
          <div>
            {tasklistTasks.map((task, index) => {
              return renderTask(task, index);
            })}
          </div>
        </DragDropProvider>
        <Button variant="outlined" sx={{ width: "100%", mt: 1 }} onClick={addTasklistTask}>+</Button>
          <Button variant="contained" color="primary" sx={{ mt: 2 }} onClick={formSubmit}>
              Submit
          </Button>
          {String(props.mode) === String("add") ? null:<Button variant="contained" color="primary" sx={{ mt: 2 }} onClick={()=>{props.deleteTasklist(tasklist); handleClose()}}>
              Delete
          </Button>}
          </Box>
      </Modal>
    )
  }

function Tasklists(props){

    const { keycloak } = useKeycloak();
    const a = new ApiConfig(keycloak)
    const apiConfig = a.api()

    const [mode, setMode] = useState("add")
    const [openAddTasklist, setOpenAddTasklist] = useState(false);
    const handleAddTasklistClose = () => {setEditingTasklist(null);setOpenAddTasklist(false)};
    const handleAddTasklistOpen = (mode) => {retrieveTasklists(); setMode(mode); setOpenAddTasklist(true);};

    const [tasks, setTasks] = useState([])
    const [tasklists, setTasklists] = useState([])
    const [editingTasklist, setEditingTasklist] = useState(null)

    const retrieveTasklists = () => {
        // setTasks([])
        // setTasklists([])
        // setMissions([])
        Promise.all([
          apiConfig.fetchTaskInfo(),
          apiConfig.fetchTasklistInfo(),
        ]).then(results => {
            // console.log(results[0].RobotResponse)
            // console.log(results[1].RobotResponse)
            // console.log(results[2].RobotResponse)
            setTasks(results[0].RobotResponse)
            setTasklists(results[1].RobotResponse)
        }).catch(error => {
            console.error(error);
        });
      }

    useMountEffect(() => {
        // console.log(props)
        retrieveTasklists()
        return () => {
            // This code runs when the component is unmounted
            // Perform cleanup or unsubscribe from resources
            // console.log("Disconnecting from websocket...")
            // socket.close()
        };

    }, []);

    const renderTasklist = (tasklist, index) => {
        return(
          <Button key={index} variant="outlined" sx={{ width: "100%", justifyContent: 'flex-start', mb: 0.5 }} onClick={()=>{handleAddTasklistOpen("edit");setEditingTasklist(tasklist)}}>
            {tasklist.Name}
          </Button>
        )
    }

    return(
        <Grid container display="flex" alignItems="center" justifyContent="center" direction="column" item xs={12} sm={12} md={4} lg={4} xl={4}>
            <p className={styles.font} style={{ fontSize: 20}}>Tasklists</p>
            <Button variant="outlined" sx={{ width: "100%" }} onClick={()=>{handleAddTasklistOpen("add")}}>+</Button>
            {
                tasklists.map((tasklist, index)=>{
                    return((renderTasklist(tasklist, index)))
                })
            }
        <AddTasklist mode={mode} tasklist={editingTasklist} handleClose={handleAddTasklistClose} tasks={tasks} deleteTasklist={(tasklist)=>{apiConfig.deleteTasklist(tasklist.Id).then(response=>{console.log(response); retrieveTasklists()})}} openAddTasklist={openAddTasklist} updateTasklist={(tasklist)=>{console.log(`Update tasklist `, tasklist); apiConfig.updateTasklist(tasklist.Id, tasklist).then((response)=>{console.log(response); retrieveTasklists()})}} addTasklist={(tasklist)=>{console.log(`Add tasklist `, tasklist); apiConfig.createTasklist(tasklist).then((response)=>{console.log(response); retrieveTasklists()});}}/>
        </Grid>
    )
}

export {Tasklists}